import { render } from "./PendingWithdrawals.vue?vue&type=template&id=46b7cf32&scoped=true&ts=true"
import script from "./PendingWithdrawals.vue?vue&type=script&lang=ts"
export * from "./PendingWithdrawals.vue?vue&type=script&lang=ts"

import "./PendingWithdrawals.vue?vue&type=style&index=0&id=46b7cf32&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46b7cf32"]])

export default __exports__